import { gql } from 'graphql-tag';

export const GET_AUTHOR_ID = gql`
  query AuthorIdByName($authorsRootPath: String!, $name: String!) {
    search(
      first: 1
      where: {
        AND: [
          { name: "_path", value: $authorsRootPath, operator: CONTAINS }
          { name: "Author Name", value: $name, operator: EQ }
        ]
      }
    ) {
      results {
        id
      }
    }
  }
`;


export const GET_CATEGORY_OR_TAG_ID = gql`
  query GetCategoryIdByName(
    $categoriesRoot: String!
    $name: String!
    $nameHtml: String!
  ) {
    search(
      first: 1
      where: {
        AND: [
          { name: "_path", value: $categoriesRoot, operator: CONTAINS }
          {
            OR: [
              { name: "Name",  value: $name,     operator: EQ }
              { name: "Name",  value: $nameHtml, operator: EQ }
              { name: "_name", value: $name,     operator: EQ }
              { name: "_name", value: $nameHtml, operator: EQ }
            ]
          }
        ]
      }
    ) {
      results { id }
    }
  }
`;
